var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    {
      staticClass: "section-white-list",
      attrs: { id: "professional-platform" }
    },
    [
      _c(
        "b-col",
        { staticClass: "content my-auto", attrs: { md: "12", lg: "6" } },
        [
          _c("div", { staticClass: "title-ctn" }, [
            _c("h4", { staticClass: "mb-3" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("abogalitypro.professional-platform.orange-title")
                )
              )
            ]),
            _vm._v(" "),
            _c("h3", [
              _vm._v(_vm._s(_vm.$t("abogalitypro.professional-platform.title")))
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "subtitle" },
            [
              _c(
                "div",
                { staticClass: "subtitle-list subtitle-list-large my-5" },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "tick-mobile", attrs: { cols: "2" } },
                        [_c("p", [_c("rounded-check-icon")], 1)]
                      ),
                      _vm._v(" "),
                      _c("b-col", { attrs: { cols: "10" } }, [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("abogalitypro.professional-platform.text1")
                            )
                          }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "tick-mobile", attrs: { cols: "2" } },
                        [_c("p", [_c("rounded-check-icon")], 1)]
                      ),
                      _vm._v(" "),
                      _c("b-col", { attrs: { cols: "10" } }, [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("abogalitypro.professional-platform.text2")
                            )
                          }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "tick-mobile", attrs: { cols: "2" } },
                        [_c("p", [_c("rounded-check-icon")], 1)]
                      ),
                      _vm._v(" "),
                      _c("b-col", { attrs: { cols: "10" } }, [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("abogalitypro.professional-platform.text3")
                            )
                          }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "tick-mobile", attrs: { cols: "2" } },
                        [_c("p", [_c("rounded-check-icon")], 1)]
                      ),
                      _vm._v(" "),
                      _c("b-col", { attrs: { cols: "10" } }, [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("abogalitypro.professional-platform.text4")
                            )
                          }
                        })
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("b-row", [
                _c("h4", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "abogalitypro.professional-platform.orange-title-final"
                      )
                    )
                  )
                ])
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "py-sm-0 py-lg-5", attrs: { md: "12", lg: "6" } },
        [_c("div", { staticClass: "col-bg ml-lg-auto" })]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-96159c2e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96159c2e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/abogalitypro/AbogalityProfessionalPlatform.vue
// module id = 4372
// module chunks = 12